import styled from "styled-components";

export const CaseSectionContainer = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
`;
